/**
 * JALRAKSHAK Digital Hub - Main Application Entry
 */

import '../styles/variables.css';
import '../styles/base.css';
import '../styles/components.css';
import '../styles/hero.css';
import '../styles/dashboard.css';
import '../styles/visiting-card.css';
import '../styles/responsive.css';

import { initNavigation } from './navigation.js';
import { initDashboard } from './dashboard.js';
import { initSimulator } from './simulator.js';
import { initModals } from './modals.js';
import { initVCard } from './vcard.js';
import { initAnimations } from './animations.js';
import { initContactForm } from './contact.js';

/**
 * Permanent QR Gateway Route Handler
 * CRITICAL NOTICE:
 * DO NOT REMOVE /go — this route is permanently encoded in printed JALRAKSHAK QR codes.
 * Ensures that if a client loads the application with /go in the path, it cleanly normalizes to /
 */
function handlePermanentQrGateway() {
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path === '/go') {
    window.history.replaceState(null, '', '/' + window.location.search + window.location.hash);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Permanent QR Route Check
  handlePermanentQrGateway();

  // Initialize Core Systems
  initNavigation();
  initDashboard();
  initSimulator();
  initModals();
  initVCard();
  initAnimations();
  initContactForm();
});

